import type { LucideIcon } from "lucide-react";

type Size = "sm" | "md" | "lg";

const box: Record<Size, string> = { sm: "h-10 w-10", md: "h-11 w-11", lg: "h-14 w-14" };
const glyph: Record<Size, string> = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-6 w-6" };

/** Einheitliches Icon-Badge für die gesamte Website: weicher Clay-Kreis. */
export const IconChip = ({ icon: Icon, size = "md", className = "" }: { icon: LucideIcon; size?: Size; className?: string }) => (
  <span className={`grid shrink-0 place-items-center rounded-full bg-clay/10 text-clay transition-[background-color,color] duration-300 group-hover:bg-clay group-hover:text-cream ${box[size]} ${className}`}>
    <Icon className={glyph[size]} aria-hidden />
  </span>
);
